import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { EntitySettings, IrreversableModal } from 'screens/Admin/components';

const Settings = ({ product, closeModal }) => {
  const [visible, setVisible] = useState(null),
    [loading, setLoading] = useState(false),
    dispatch = useDispatch();

  async function handleRemove() {
    setLoading(true);

    // Add remove order later
    const res = {};

    setLoading(false);
    if (!res) return;

    closeModal();
  }

  if (!product) return null;

  const settings = [];

  return (
    <React.Fragment>
      <EntitySettings options={settings} />

      <IrreversableModal
        visible={visible === 'remove'}
        heading="You are about to remove this order."
        onConfirm={handleRemove}
        closeModal={() => setVisible(null)}
      />
    </React.Fragment>
  );
};

export default Settings;
